import React, { useMemo } from 'react';
import Button from '../Button/Button';
import { ButtonElement } from './styles';
import { SwiperSlide } from 'swiper/react';
import { cx } from '@linaria/core';
import { Dropdown } from '../Dropdown/Dropdown';
function setActiveButton(itemsState, itemIndex, setItemsState) {
    const updatedItems = [...itemsState];
    if (!updatedItems[itemIndex].isDisabled) {
        updatedItems.forEach((item) => {
            if (item.isActive) {
                item.isActive = false;
            }
        });
        updatedItems[itemIndex].isActive = true;
        setItemsState(updatedItems);
    }
}
function onButtonElementClick(hasControlledItems, itemsState, itemIndex, setItemsState) {
    if (!hasControlledItems) {
        setActiveButton(itemsState, itemIndex, setItemsState);
    }
}
function getNavBarButton(item, buttonRole, buttonType) {
    const button = React.createElement(Button, { type: buttonType, accessibility: buttonRole, ...item });
    if (item.subNav) {
        return (React.createElement(Dropdown, { isFullwidth: false, id: "account-context-menu", hasArrow: true, hasActiveCheckmarkIcon: false, ...item.subNav, selectButton: { accessibility: buttonRole, ...item } }));
    }
    else {
        return button;
    }
}
function useNavbarButtons(hasControlledItems, itemsState, setItemsState, buttonRole, role, buttonType) {
    return useMemo(() => {
        return itemsState.map((item, itemIndex) => (React.createElement("li", { className: cx(ButtonElement.base), key: `${item.text}_${itemIndex}`, role: role, onClick: (e) => {
                onButtonElementClick(hasControlledItems, itemsState, itemIndex, setItemsState);
            }, "aria-label": role !== 'presentation' && item.text ? item.text : undefined }, getNavBarButton(item, buttonRole, buttonType))));
    }, [itemsState]);
}
function useNavbarButtonsSwipable(itemsState, hasControlledItems, setItemsState, buttonRole, buttonType) {
    return useMemo(() => {
        const swipableItems = itemsState.map((item, i) => (React.createElement(SwiperSlide, { key: `${item.text}_${i}`, role: "presentation", onClick: (e) => {
                onButtonElementClick(hasControlledItems, itemsState, i, setItemsState);
            } }, getNavBarButton(item, buttonRole, buttonType))));
        return swipableItems;
    }, [itemsState]);
}
function useButtons(itemsState, setItemsState, hasControlledItems, accessibility, buttonType) {
    const buttonRole = accessibility ? (accessibility === 'tablist' ? 'tab' : 'menuitem') : undefined;
    const role = accessibility === 'menu' ? 'presentation' : undefined;
    const memoButtons = useNavbarButtons(hasControlledItems, itemsState, setItemsState, buttonRole, role, buttonType);
    const memoButtonsSwipable = useNavbarButtonsSwipable(itemsState, hasControlledItems, setItemsState, buttonRole, buttonType);
    return { memoButtons, memoButtonsSwipable };
}
export default useButtons;
